import type { IconDefinition } from '../index.tsx';

export const iconYoutube: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconYoutube',
  icon: [
    16,
    16,
    [],
    '',
    'M15.649 4.16929C15.4735 3.46728 14.9177 2.91152 14.245 2.73602C12.9872 2.38501 8.01463 2.38501 8.01463 2.38501C8.01463 2.38501 3.0128 2.38501 1.75503 2.73602C1.08227 2.91152 0.526508 3.46728 0.351005 4.16929C0 5.39781 0 8.03035 0 8.03035C0 8.03035 0 10.6336 0.351005 11.8914C0.526508 12.5934 1.08227 13.1199 1.75503 13.2954C3.0128 13.6172 8.01463 13.6172 8.01463 13.6172C8.01463 13.6172 12.9872 13.6172 14.245 13.2954C14.9177 13.1199 15.4735 12.5934 15.649 11.8914C16 10.6336 16 8.03035 16 8.03035C16 8.03035 16 5.39781 15.649 4.16929ZM6.3766 10.3996V5.66106L10.5302 8.03035L6.3766 10.3996Z',
  ],
};
